(function() {
    'use strict';

    angular.module('mnp.common', [ 'ngAnimate', 'ui.router'
    ]);
})();
